import { Component, Inject, OnInit} from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StatusConstant } from '../status/status-constant';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';

@Component({
  selector: 'app-selectPromptTemplate',
  templateUrl: './selectPromptTemplate.component.html',
  styleUrls: ['./selectPromptTemplate.component.scss'] 
})

export class SelectPromptTemplateComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;   
  spinner:boolean=false;
  OfficeIDList: any=[];
  myOfficeID: any;

 //iconList:any=[]=[];
 selectedIconId:number=0;


 

  constructor(public dialogRef: MatDialogRef<SelectPromptTemplateComponent>,  
   private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,private statusConst: StatusConstant,
    private settingsService: SettingService) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    } 
  }  
  
  ngOnInit(): void {  
     this.categoryType=0; 
     this.QuestionTemplateIDImportTask=0;
     this.selectedcategoryIDForQuestion=0;
     this.currentIndex=0;    
     this.getActiveQuestionTemplateAfterAdd("");  
     this.getNLPTemplates();   
   }            
  
   closePopUp() {
    this.dialogRef.close();
  }

  iconSelect(data:any){
    this.dialogRef.close(data);    
  }

  selectedTemplate:any=[]=[];
  QuestionCategoryList:any=[]=[];
  filteredQuestionCategoryList:any=[]=[];
  QuestionTemplateIDImportTask:number=0;
  categoryType:number=0;
  selectedcategoryIDForQuestion:number=0;
  NLPTemplatesList:any=[]=[];
  NLPTemplatesListFilter:any=[]=[];
  ShowNoRecordFoundQuestionTemplate:boolean=false;
  currentIndex:number=0;
  tempalteName:string="";

  OnSelectCategoryImportTemp($event) {
    this.selectedTemplate=[];
    this.QuestionTemplateIDImportTask=0;
    //this.selectedTaskCategoryID = 0;
    const textLabel = $event.value;
    const categoryValue = textLabel == 'My Template' ? 0 : (textLabel == 'Organization' ? 2 : 1);  
    this.categoryType=categoryValue;
    this.getActiveQuestionTemplateAfterAdd("");
    this.getNLPTemplates();
  }
 
  getActiveQuestionTemplateAfterAdd(categoryName: string) {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      isCategoriesOnly: true,
      isAll: false,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      type: this.categoryType > 0 ? this.categoryType : 0
    }
    this.settingsService.getNLPTemplateCategories(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        //this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.QuestionCategoryList = response.data;
          this.filteredQuestionCategoryList = this.QuestionCategoryList.filter(m => m.type == this.categoryType);
          if(categoryName!=""){            
            var check = [];
            check = this.QuestionCategoryList.filter(x => x.nlpTemplateCategoryName.toLowerCase() == categoryName.toLowerCase());
            if (check.length > 0) {
              //this.addTemplateForm.controls['folderID'].setValue(check[0].nlpTemplateCategoryID);
            }
          }         
        }else {
          this.QuestionCategoryList = [];
          this.filteredQuestionCategoryList = [];
        }
      }else {
        this.QuestionCategoryList = [];
        this.filteredQuestionCategoryList = [];
      }
    });
  }

  getNLPTemplates() {
    var ReqModel = {
      templateType: this.categoryType,// For My Template      
      categoryID:this.selectedcategoryIDForQuestion,     
      isAll: true,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)     
    }
    this.settingsService.getNLPTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        //this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.NLPTemplatesList = response.data;
          this.NLPTemplatesListFilter = response.data;
          if(this.NLPTemplatesList.length>0){
            this.ShowNoRecordFoundQuestionTemplate=false;
          }else{
            this.ShowNoRecordFoundQuestionTemplate=true;
          }          
        }else {
          this.NLPTemplatesList = [];   
          this.NLPTemplatesListFilter=[];      
        }
      }else {
        this.NLPTemplatesList = [];   
        this.NLPTemplatesListFilter=[];       
      }
    });
   }

 
   officeIdForImportPromptTemp:number=0;
   organizationIdForImportPromptTemp:number=0;

   SelectTemplateQuestionTempForImport(data){
    this.officeIdForImportPromptTemp= data.officeID;
    this.organizationIdForImportPromptTemp = data.organizationID;
    this.QuestionTemplateIDImportTask = data.templateID;
    this.tempalteName= data.tempalteName;
   }

   getThroughCategoryForQuestionTempImport(e: any, i: any) { 
    this.QuestionTemplateIDImportTask=0;
    this.currentIndex = i;
    this.selectedcategoryIDForQuestion=e;
    this.getNLPTemplates();
   }

   importQuestionTemplates(){
    var obj={
      tempalteName:this.tempalteName,
      templateID:this.QuestionTemplateIDImportTask
    }
    this.dialogRef.close(obj);
   }

   closeImportQuestionTemplate(){
    this.dialogRef.close();
   }

}
